export const extractDomain = (raw: string): string | null => {
  try {
    const trimmed = raw?.trim();
    if (!trimmed) return null;
    const parsed = new URL(trimmed);
    return parsed.hostname.toLowerCase().replace(/^www\./, "");
  } catch {
    return null;
  }
};

export const extractOrigin = (raw: string): string | null => {
  try {
    const trimmed = raw?.trim();
    if (!trimmed) return null;
    const parsed = new URL(trimmed);
    const hostname = parsed.hostname.toLowerCase().replace(/^www\./, "");
    return `https://${hostname}`;
  } catch {
    return null;
  }
};

const domainLabelPattern = "[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?";
const domainPattern = new RegExp(
  `^(?=.{1,253}$)(?:${domainLabelPattern}\\.)+(?:[A-Za-z]{2,63}|xn--[A-Za-z0-9-]{1,59}[A-Za-z0-9])$`
);

export const isValidIframeUrl = (raw: string): boolean => {
  try {
    const trimmed = raw?.trim();
    if (!trimmed || trimmed.includes("@")) return false;

    const parsed = new URL(trimmed);
    const hasAllowedProtocol =
      parsed.protocol === "https:" || parsed.protocol === "http:";
    return hasAllowedProtocol && domainPattern.test(parsed.hostname);
  } catch {
    return false;
  }
};

export const collectIframeDomains = (root: ParentNode): string[] => {
  const domains = new Set<string>();
  root.querySelectorAll("iframe").forEach((node) => {
    const domain = extractDomain((node as HTMLIFrameElement).src);
    if (domain) domains.add(domain);
  });
  return Array.from(domains);
};

export const collectIframeOrigins = (root: ParentNode): string[] => {
  const origins = new Set<string>();
  root.querySelectorAll("iframe").forEach((node) => {
    const origin = extractOrigin((node as HTMLIFrameElement).src);
    if (origin) origins.add(origin);
  });
  return Array.from(origins);
};
